import type { SVGProps } from '@integrations/react'
import { uiSize } from '@utils'

interface Props extends Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> {
  /** Rendered width and height in px; `null` leaves sizing to the host's CSS. */
  size?: number | null
}

function CashIcon({ size = 14, strokeWidth = 2, ...props }: Props) {
  return (
    <svg
      width={uiSize(size)}
      height={uiSize(size)}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={strokeWidth}
      aria-hidden='true'
      {...props}
    >
      <rect x='3' y='7' width='18' height='10' rx='2' />
      <circle cx='12' cy='12' r='2.5' />
    </svg>
  )
}

export default CashIcon
